angular.module("avant.filters").filter "StageToAction", ->
  (stage) ->
    switch stage
      when "personal" then "Complete Your Personal Information"
      when "rates_terms" then "Customize Your Rates & Terms"
      when "contract" then "Sign Your Contract"
      when "bank_account" then "Enter Your Bank Account Information"
      when "additional_information" then "Fill In Any Additional Information"
